import axios from 'axios';
import { responseHandler, errorHandler } from './response-interceptor';
import qs from 'qs';
import { CONTENT_TYPE } from '@/apis/constant';
import _ from "lodash";
import { flowTypes } from '@/common/service/page-config';

export const previewWrapper = (fn, type) => {
  return (params) => {
    const {preview} = params;
    if(preview == true){
      return axios.post(`/opc/plan/preview?flowType=${type}`, params)
    }else{
      return fn(params);
    }
  }
}

export const getOpenInvoice = () => axios.get('/opc/invoice/overdue');

// axios.defaults.headers.post['X-CSRF-TOKEN'] = document.querySelector("input[name='_csrf']")?.value ?? "";

axios.interceptors.response.use(responseHandler, errorHandler);

// get plan map
export const getPlanMap = (
  isC50Plan = true,
  isGetNonStandardBillingCyclePlan = false,
  needTollfeeUnlimited = false,
  isFromCouponCampaign = false
) => {
  const externalParams = _.pickBy({
    isGetNonStandardBillingCyclePlan,
    isFromCouponCampaign
  }, (v) => v);

  const searchString = qs.stringify({
    isC50Plan: isC50Plan ? 1 : 0,
    needTollfeeUnlimited,
    ...externalParams,
    _: Math.random(),
  });

  return axios.get(`/billing/basic/plan?${searchString}`);
};

// get currency with disabled plan or functional switch etc...
export const getBasicConfig = () => axios.get('/billing/basic/config');

// polling event status
export const billingEventPolling = (previewKey) => axios.get(`/billing/event/status${previewKey ? `?previewKey=${previewKey}` : ''}`);
// net new customer place order interface, not support preview
export const buySubscription = (params) => axios.post('/opc/buy/subscription', params);
// free account place order interface, not support preview
export const freeUpgrade = (params) => axios.post('/opc/free/upgrade', params);
// meeting pro upgrade plan
export const freeTrialUpgrade = previewWrapper((params) => axios.post('/opc/freetrial/upgrade', params), flowTypes.trial2paid);

export const getEssentialAppList = (page = 1, size = 50) => axios.get(`/marketplace/essential_apps?page_size=${page}&page_num=${size}`);
// get account subscription
export const getSubscriptions = () => axios.get('/billing/basic/subscription?from=opcEdit')
  .then((data) => data?.result || [])
  .catch(() => Promise.resolve([]));

// get account with pbx subscription
export const getPbxSubscriptions = (params = {}) => axios.get('/billing/pbx/subscriptions', { params })
  .then((data) => data?.result || [])
  .catch(() => Promise.resolve([]));

// edit update
export const updatePlans = previewWrapper((params) => axios.post('/opc/plan/update', params), 'edit');

/**
 * Support Case:
    online free trial account add plan
    op free trial account add plan
    op pay by check account add plan
 */
export const purchasePlan = (params) => axios.post('/opc/plan/purchase', params);

export const queryDowngradeLicenses = (planCodeList = []) => {
  return axios.post('/billing/licenses/downgrade/query', qs.stringify({ planCodeList: JSON.stringify(planCodeList) }), {
    headers: {
      'Content-Type': CONTENT_TYPE.URL_ENCODED,
    },
  });
};

// add addon
export const addAddonPlans = previewWrapper((params) => axios.post('/opc/plan/add', params), 'add');

// FREE TRIAL - add free trial
export const addFreeTrialPlans = previewWrapper((params) => axios.post('/opc/freetrial/add', params), flowTypes.add2trial);

// BUY TRIAL - buy free trial, not support preview
export const buyFreeTrialPlans = (params) => axios.post('/opc/freetrial/buy_now', params)

// BUY TRIAL - free account buy free trial, not support preview
export const buyFreeTrialPlansForFreeUser = (params) => axios.post('/opc/freetrial/free_upgrade', params)

// check bulk license downsell case
export const validateEditBulkLicense = (params) => axios.post('/account/validate_edit_bulk_license', qs.stringify(params), {
  headers: {
    'Content-Type': CONTENT_TYPE.URL_ENCODED,
  },
});

// cmr used value
export const getCmrUsedValue = () => axios.get('/billing/plan/cloud_storage')
  .then((data) => data?.result || [])
  .catch(() => Promise.resolve([]));


  // get capacity config
export const capacityConfig = (params) => axios.get('/opc/plan/capacity', {params});

export const getAudioCountries = currency => axios.get(`/billing/audio/${currency}/default-rate`);

export const getVideoSdkUcCreditRates = () => axios.get('/pricing/universal_credit/rate');

export function createLeadForAbandonedCart(data) {
  return axios.post('/opc/lead_form', data);
}

// get account subscription
export const getFreeTrialPlansByCampaignName = (campaignName) => axios.get(`/billing/basic/free_trial/metadata/${campaignName}`)
  .then((data) => ({ result: data?.result || [], errorMessage: data?.errorMessage || ''}))
  .catch(() => Promise.resolve([]));

// preview eligibility
export const getPreviewEligibility = (data) => axios.post('/opc/preview/support_check', data);


export const getPPARemainingCredits = (planCode) => axios.get(`/billing/plan/ppa_remaining_credits?planCode=${planCode}`);

export const checkZeSaasCapacity= ({srcPlanCode, targetPlanCode, isDowngrade}) => axios.get(`/billing/plan/saas_capacity_check?srcPlanCode=${srcPlanCode}&targetPlanCode=${targetPlanCode}&isDowngrade=${isDowngrade}`);

export const checkUpcomingWebinars= ({srcPlanCode, targetPlanCode}) => axios.get(`/billing/webinar/upcoming_event_check?srcPlanCode=${srcPlanCode}&targetPlanCode=${targetPlanCode}`);

export const planReactiveRequest = (params) => axios.post('/billing/plan/reactivate', params)

export const getPastList = (params) => axios.get('/billing/plan/past_list', { params });

// Postoned to Dec release
// export const planReactiveSubPlanRequest = (params) => axios.post('/billing/plan/reactivate_subplan', qs.stringify(params), {
//   headers: {
//     'Content-Type': CONTENT_TYPE.URL_ENCODED
//   }
// })

export const pingServerSession = () => {
  return axios.get('/zoomevents/ping');
}

export const getSnowplowConfig = () => axios.get('/billing/telemetry/snowplow')

export const getAllPlanPrice = () => axios.get('/pricing/planPrice.json');